import { render, staticRenderFns } from "./edit-form-item.vue?vue&type=template&id=586a1b44&scoped=true&"
import script from "./edit-form-item.vue?vue&type=script&lang=ts&"
export * from "./edit-form-item.vue?vue&type=script&lang=ts&"
import style0 from "./edit-form-item.vue?vue&type=style&index=0&id=586a1b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a1b44",
  null
  
)

export default component.exports